(() => {
  const REVIEW_TARGET_ID = "judgeme-reviews";
  const TEXT_SELECTORS = [
    ".stars",
    ".rating",
    ".prehead",
    ".pg-review-link",
    ".review-count",
    ".cf-eyebrow",
    ".sc-signs-stars",
    "p",
    "small"
  ].join(",");

  const target = () => document.getElementById(REVIEW_TARGET_ID);
  const isReviewReference = (text = "") => /review/i.test(text) || /\d[\d,.]*\+?.{0,35}cat parent/i.test(text) || /cat parent.{0,35}\d[\d,.]*\+?/i.test(text);

  const scrollToReviews = (event) => {
    const section = target();
    if (!section) return;
    if (event) event.preventDefault();
    section.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.replaceState(null, "", `#${REVIEW_TARGET_ID}`);
  };

  const makeReviewCountsLinks = () => {
    document.querySelectorAll(TEXT_SELECTORS).forEach((element) => {
      if (element.closest(`#${REVIEW_TARGET_ID}`)) return;
      if (element.closest("a,button")) return;
      if (!isReviewReference(element.textContent || "")) return;

      const interactive = element.matches("a,button") ? element : element.querySelector(":scope > a, :scope > button");
      if (interactive) {
        interactive.dataset.scReviewsLink = "";
        if (interactive.tagName === "A") interactive.setAttribute("href", `#${REVIEW_TARGET_ID}`);
        return;
      }

      const link = document.createElement("a");
      link.href = `#${REVIEW_TARGET_ID}`;
      link.className = "sc-reviews-link";
      link.dataset.scReviewsLink = "";
      while (element.firstChild) link.appendChild(element.firstChild);
      element.appendChild(link);
    });

    document.querySelectorAll("a,button").forEach((element) => {
      if (element.closest(`#${REVIEW_TARGET_ID}`)) return;
      const pointsToReviews = element.getAttribute("href") === "#reviews";
      if (!pointsToReviews && !isReviewReference(element.textContent || "")) return;
      element.dataset.scReviewsLink = "";
      if (element.tagName === "A") element.setAttribute("href", `#${REVIEW_TARGET_ID}`);
    });
  };

  const moveBeforeFooter = () => {
    const section = target();
    if (!section) return;
    const footers = [...document.querySelectorAll("footer:not(.sc-cart-drawer__footer)")]
      .filter((footer) => !footer.closest("[data-supercat-cart-drawer]"));
    const footer = footers.at(-1);
    if (footer && section.nextElementSibling !== footer) footer.parentNode.insertBefore(section, footer);
  };

  const init = () => {
    moveBeforeFooter();
    makeReviewCountsLinks();

    document.addEventListener("click", (event) => {
      const trigger = event.target.closest(`[data-sc-reviews-link], a[href="#reviews"], a[href="#${REVIEW_TARGET_ID}"]`);
      if (!trigger || trigger.closest(`#${REVIEW_TARGET_ID}`)) return;
      scrollToReviews(event);
    });

    if (window.location.hash === `#${REVIEW_TARGET_ID}`) {
      requestAnimationFrame(() => target()?.scrollIntoView({ behavior: "smooth", block: "start" }));
    }
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
